/**
 * Wrapper di route che richiede autenticazione.
 * Se l'utente non è autenticato, redirige a /login con `state.from`
 * per poter tornare alla pagina richiesta dopo il login.
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext.js';
import type { ReactNode } from 'react';

interface RequireAuthProps {
  children: ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Preserva la destinazione originale nel state per redirect post-login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
